// Validate the original input before removing only supported visual separators.
export function normalizePhone(value) {
  const raw = String(value ?? "")
  if (/[^0-9+ ()-]/.test(raw)) {
    return { isValid: false, message: "Телефон может содержать только цифры 0–9, ведущий +, пробелы, скобки и дефисы" }
  }
  if (raw.includes("+") && (raw[0] !== "+" || raw.indexOf("+", 1) !== -1)) {
    return { isValid: false, message: "Знак + допускается только один раз в начале номера" }
  }
  if (raw.replace(/ /g, "") === "") return { isValid: true, value: "" }
  const normalized = raw.replace(/[ ()-]/g, "")
  if (!/^\+?[0-9]{7,15}$/.test(normalized)) {
    return { isValid: false, message: "Номер телефона должен содержать от 7 до 15 цифр" }
  }
  return { isValid: true, value: normalized }
}
